import {supabase} from './supabaseClient'

export const getTowelsByStatus = async (statuses: string[]) => {
  const {data, error} = await supabase
    .from('towels')
    .select(
      `
      *,
zone:zones!towels_zone_id_fkey(nombre),
      transactions (
        id,
        estado,
        hora_entrega,
        hora_devolucion,

        member_nombre,
        member_apellido,
        member_cedula,
        member_numero_accion,

        zone:zones!towels_zone_id_fkey(nombre),

        operator:profiles!transactions_operator_id_fkey(
          nombre,
          apellido,
          rol
        )
      )
    `
    )
    .in('estado', statuses)

  if (error) throw error

  return data
}

export const getTowelsForDelivery = async () => {
  const pageSize = 1000
  let allTowels: any[] = []
  let from = 0
  let keepGoing = true

  while (keepGoing) {
    const {data, error} = await supabase
      .from('towels')
      .select('*')
      .order('codigo', {ascending: true})
      .range(from, from + pageSize - 1)

    if (error) throw error

    allTowels = [...allTowels, ...(data || [])]

    if (!data || data.length < pageSize) {
      keepGoing = false
    } else {
      from += pageSize
    }
  }

  return allTowels
}

export const assignTowel = async (
  towelIds: string[],
  payload: {
    member_id: string
    member_nombre?: string
    member_apellido?: string
    member_cedula?: string
    member_numero_accion?: string
    zone_id: string
    operator_id: string
  }
) => {
  const {data: activeTransactions, error: activeError} = await supabase
    .from('transactions')
    .select('id, towel_id')
    .in('towel_id', towelIds)
    .eq('estado', 'en_uso')

  if (activeError) throw activeError

  if (activeTransactions?.length) {
    const {error: closeError} = await supabase
      .from('transactions')
      .update({
        estado: 'devuelta',
        hora_devolucion: new Date().toISOString(),
      })
      .in(
        'id',
        activeTransactions.map((tx) => tx.id)
      )

    if (closeError) throw closeError

    for (const tx of activeTransactions) {
      const {error} = await supabase.rpc('increment_lavados', {
        towel_id: tx.towel_id,
      })

      if (error) throw error
    }
  }

  const transactions = towelIds.map((towelId) => ({
    towel_id: towelId,

    member_id: payload.member_id,
    member_nombre: payload.member_nombre,
    member_apellido: payload.member_apellido,
    member_cedula: payload.member_cedula,
    member_numero_accion: payload.member_numero_accion,

    zone_id: payload.zone_id,
    operator_id: payload.operator_id,

    hora_entrega: new Date().toISOString(),

    estado: 'en_uso',
  }))

  const {error: txError} = await supabase.from('transactions').insert(transactions)

  if (txError) throw txError

  const now = new Date().toISOString()

  const {error: towelError} = await supabase
    .from('towels')
    .update({
      estado: 'en_uso',
      ultima_fecha_uso: now,
      zone_id: payload.zone_id,
    })
    .in('id', towelIds)

  if (towelError) throw towelError
}

export const returnTowel = async (towelIds: string[]) => {
  const {data: transactions, error: findError} = await supabase
    .from('transactions')
    .select('*')
    .in('towel_id', towelIds)
    .eq('estado', 'en_uso')

  if (findError) throw findError

  if (!transactions?.length) {
    throw new Error('No existen transacciones activas')
  }

  const transactionIds = transactions.map((tx) => tx.id)

  const {error: updateTxError} = await supabase
    .from('transactions')
    .update({
      hora_devolucion: new Date().toISOString(),
      estado: 'devuelta',
    })
    .in('id', transactionIds)

  if (updateTxError) throw updateTxError

  for (const towelId of towelIds) {
    const {error} = await supabase.rpc('increment_lavados', {
      towel_id: towelId,
    })

    if (error) throw error
  }

  const {data: laundryZone, error: zoneError} = await supabase
    .from('zones')
    .select('id')
    .eq('nombre', 'Lavanderia')
    .single()

  if (zoneError || !laundryZone) {
    throw new Error('No se encontró la zona de Lavanderia en el sistema')
  }

  const {error: towelError} = await supabase
    .from('towels')
    .update({
      estado: 'lavanderia',
      zone_id: laundryZone.id,
    })
    .in('id', towelIds)

  if (towelError) throw towelError
}

// NUEVA FUNCION PARA OBTENER TOALLAS ACTIVAS POR SOCIO

export const getActiveTransactionsByMember = async (numeroAccion: string) => {
  const {data, error} = await supabase
    .from('transactions')
    .select(
      `
      id,
      member_nombre,
      member_apellido,
      member_numero_accion,
      hora_entrega,

      towel:towels(
        id,
        codigo,
        tipo
      )
    `
    )
    .eq('member_numero_accion', numeroAccion)
    .eq('estado', 'en_uso')
    .order('hora_entrega', {ascending: false})

  if (error) throw error

  return data || []
}

export const getActiveMembersSuggestions = async () => {
  const {data, error} = await supabase
    .from('transactions')
    .select(
      `
      member_nombre,
      member_apellido,
      member_numero_accion,
      hora_entrega
    `
    )
    .eq('estado', 'en_uso')
    .order('hora_entrega', {ascending: false})

  if (error) throw error

  const uniqueMembers =
    data?.filter(
      (item, index, self) =>
        index === self.findIndex((m) => m.member_numero_accion === item.member_numero_accion)
    ) || []

  return uniqueMembers.slice(0, 5)
}

export const getTowelsByIds = async (ids: string[]) => {
  if (!ids || ids.length === 0) return []

  const {data, error} = await supabase.from('towels').select('*').in('id', ids)

  if (error) throw error

  return data
}

export const searchTowelsByCode = async (query: string, limit = 20) => {
  if (!query) return []

  const {data, error} = await supabase
    .from('towels')
    .select('*')
    .eq('activa', true)
    .ilike('codigo', `%${query}%`)
    .order('codigo', {ascending: true})
    .limit(limit)

  if (error) throw error

  return data || []
}

export const getTowelSuggestions = async (limit = 12) => {
  const {data, error} = await supabase.from('towels').select('*').eq('activa', true).limit(limit)

  if (error) throw error

  return data || []
}

export const searchActiveTowelsByCode = async (query: string) => {
  if (!query) return []

  const {data, error} = await supabase
    .from('transactions')
    .select(
      `
      id,
      member_nombre,
      member_apellido,
      member_numero_accion,
      hora_entrega,
      towel:towels!inner(
        id,
        codigo,
        tipo
      )
    `
    )
    .eq('estado', 'en_uso')
    .ilike('towel.codigo', `%${query}%`)
    .order('hora_entrega', {ascending: false})
    .limit(20)

  if (error) throw error

  return data || []
}

export const searchActiveMembersByQuery = async (query: string) => {
  if (!query) return []

  const {data, error} = await supabase
    .from('transactions')
    .select('member_nombre, member_apellido, member_numero_accion')
    .eq('estado', 'en_uso')
    .or(`member_numero_accion.ilike.%${query}%,member_nombre.ilike.%${query}%`)
    .limit(50)

  if (error) throw error

  const uniqueMembers = (data || []).filter(
    (item, index, self) =>
      index === self.findIndex((m) => m.member_numero_accion === item.member_numero_accion)
  )

  return uniqueMembers.slice(0, 10)
}
